import React from "react";
import { Link } from "react-router-dom";
import Logo from "../images/logo/amr_logo.png";
import BannerImage from "../images/banner/banner-account1.jpg";

function Error404() {
  return (
    <section
      style={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        background:
          "linear-gradient(135deg, rgba(21, 99, 223, 0.12) 0%, rgba(21, 99, 223, 0.04) 45%, #ffffff 100%)",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top left, rgba(21, 99, 223, 0.18), transparent 36%), radial-gradient(circle at bottom right, rgba(238, 103, 66, 0.14), transparent 30%)",
          pointerEvents: "none",
        }}
      />

      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div className="row align-items-center min-vh-100 py-5">
          <div className="col-lg-6 mb-5 mb-lg-0">
            <div
              style={{
                maxWidth: 560,
              }}
            >
              <img
                src={Logo}
                alt="Ask Me Realty"
                style={{ width: 170, marginBottom: 28 }}
              />

              {/* <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "10px 18px",
                  borderRadius: 999,
                  background: "rgba(21, 99, 223, 0.1)",
                  color: "#1563df",
                  fontWeight: 700,
                  letterSpacing: 0.8,
                  textTransform: "uppercase",
                  marginBottom: 24,
                }}
              >
                Page Not Found
              </div> */}

              <h1
                style={{
                  fontSize: "clamp(4rem, 12vw, 8.5rem)",
                  lineHeight: 0.9,
                  fontWeight: 900,
                  color: "#1563df",
                  marginBottom: 20,
                }}
              >
                404
              </h1>

              <h2
                style={{
                  fontSize: "clamp(1.9rem, 4vw, 3rem)",
                  lineHeight: 1.1,
                  fontWeight: 800,
                  color: "#161e2d",
                  marginBottom: 16,
                }}
              >
                We could not find the page you were looking for.
              </h2>

              <p
                style={{
                  fontSize: 18,
                  lineHeight: 1.75,
                  color: "#5c6368",
                  marginBottom: 30,
                  maxWidth: 520,
                }}
              >
                The link may be broken, or the page may have been moved. Use the
                buttons below to return home or visit our contact page.
              </p>

              <div className="d-flex flex-wrap gap-3">
                <Link
                  to="/"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#1563df",
                    borderColor: "#1563df",
                    padding: "14px 28px",
                    fontWeight: 700,
                    borderRadius: 999,
                    boxShadow: "0 14px 32px rgba(21, 99, 223, 0.2)",
                  }}
                >
                  Back to Home
                </Link>

                <Link
                  to="/contact-us"
                  className="btn btn-outline-primary"
                  style={{
                    padding: "14px 28px",
                    fontWeight: 700,
                    borderRadius: 999,
                    borderColor: "#1563df",
                    color: "#1563df",
                  }}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div
              style={{
                position: "relative",
                borderRadius: 32,
                overflow: "hidden",
                minHeight: 520,
                boxShadow: "0 30px 60px rgba(0, 0, 0, 0.12)",
                backgroundColor: "#1563df",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `linear-gradient(180deg, rgba(21, 99, 223, 0.15), rgba(11, 33, 50, 0.75)), url(${BannerImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  left: 24,
                  right: 24,
                  bottom: 24,
                  padding: 24,
                  borderRadius: 24,
                  background: "rgba(255, 255, 255, 0.14)",
                  backdropFilter: "blur(14px)",
                  color: "#ffffff",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "8px 14px",
                    borderRadius: 999,
                    background: "rgba(255, 255, 255, 0.16)",
                    fontWeight: 700,
                    marginBottom: 14,
                  }}
                >
                  Ask Me Realty
                </div>

                <h3 style={{ fontSize: 28, fontWeight: 800, marginBottom: 10 }}>
                  Discover the right property from our homepage.
                </h3>

                <p style={{ marginBottom: 0, fontSize: 16, lineHeight: 1.7 }}>
                  Explore featured listings, services, and local support from the
                  main site navigation.
                </p>
              </div>

              <div
                style={{
                  position: "absolute",
                  top: 24,
                  right: 24,
                  padding: "12px 16px",
                  borderRadius: 18,
                  background: "rgba(255, 255, 255, 0.9)",
                  color: "#1563df",
                  fontWeight: 800,
                  boxShadow: "0 10px 24px rgba(0, 0, 0, 0.16)",
                }}
              >
               Page not found - Error 404
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Error404;
